import { render, staticRenderFns } from "./WithdrawPix.vue?vue&type=template&id=471822ac&scoped=true&"
import script from "./WithdrawPix.vue?vue&type=script&lang=js&"
export * from "./WithdrawPix.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawPix.vue?vue&type=style&index=0&id=471822ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471822ac",
  null
  
)

export default component.exports